module.exports = __webpack_public_path__ + "img/procesosrapidos.eebfa4c3.png";